module.exports = __webpack_public_path__ + "static/media/1.f0ebb0d7.png";